var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", {
        attrs: {
          "no-padding": "",
          icon: "group_work",
          title: _vm.currentAnalyteDetail.DisplayName,
        },
      }),
      _vm._v(" "),
      _c("AnalyteDetailInformation", {
        staticClass: "mb-3",
        attrs: {
          analyteData: _vm.currentAnalyteDetail,
          analyteGuidelines: _vm.analyteGuidelines,
        },
      }),
      _vm._v(" "),
      _c("AnalyteAliaManagement", {
        staticClass: "mb-3",
        attrs: { analyteData: _vm.currentAnalyteDetail },
      }),
      _vm._v(" "),
      _c("AnalyteGuidelinesManagement", {
        staticClass: "mb-3",
        attrs: { analyteData: _vm.currentAnalyteDetail },
        on: { setAnalyteGuidelines: _vm.setAnalyteGuidelines },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }